import { useNavigate } from "@tanstack/react-router";

const TaskNotFound = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigate = useNavigate() as any;

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 animate-dialog-backdrop"
      onClick={() => navigate({ to: "/", search: (prev: Record<string, unknown>) => prev })}
    >
      <div
        className="bg-warm-bg-card rounded-2xl p-8 max-w-md mx-4 text-center shadow-xl animate-dialog-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-5xl mb-4">🔍</div>
        <h2 className="text-xl font-semibold text-warm-text-primary mb-2">
          Task not found
        </h2>
        <p className="text-warm-text-secondary mb-6">
          This task may have been deleted or the link is invalid.
        </p>
        <button
          onClick={() => navigate({ to: "/", search: (prev: Record<string, unknown>) => prev })}
          className="px-6 py-2.5 bg-warm-blue text-white rounded-lg hover:opacity-90 transition-opacity"
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export default TaskNotFound;
